<template>
  <d-modal
    class="crm-new-popup calendar-popup"
    v-if="showModal"
    @close="closeModal">
    <d-modal-header>
      <d-modal-title>
        <h3 class="calendar-popup-page-title weighing-module-title">
          Kalendarz zamówień
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-container
        fluid
        class="px-4">
        <!-- Page Header -->
        <article
          class="order__MyDatepicker"
          id="calendar">
          <div class="order__MyDatepicker_header">
            <div class="order__MyDatepicker_header_date">
              <div class="order__MyDatepicker_header_date_more">
                <d-button
                  class="order__MyDatepicker_header_date_more_button"
                  @click.prevent="dateUp"
                  theme="light">
                  <i class="material-icons">keyboard_arrow_up</i>
                </d-button>
                <d-button
                  class="order__MyDatepicker_header_date_more_button"
                  @click.prevent="monthUp"
                  theme="light">
                  <i class="material-icons">keyboard_arrow_up</i>
                </d-button>
                <d-button
                  class="order__MyDatepicker_header_date_more_button"
                  @click.prevent="yearUp"
                  theme="light">
                  <i class="material-icons">keyboard_arrow_up</i>
                </d-button>
                <div>{{date.date}}</div>
                <div>{{month[date.month - 1]}}</div>
                <div>{{date.year}}</div>
                <d-button
                  class="order__MyDatepicker_header_date_more_button"
                  @click.prevent="dateDown"
                  theme="light">
                  <i class="material-icons">keyboard_arrow_down</i>
                </d-button>
                <d-button
                  class="order__MyDatepicker_header_date_more_button"
                  @click.prevent="monthDown"
                  theme="light">
                  <i class="material-icons">keyboard_arrow_down</i>
                </d-button>
                <d-button
                  class="order__MyDatepicker_header_date_more_button"
                  @click.prevent="yearDown"
                  theme="light">
                  <i class="material-icons">keyboard_arrow_down</i>
                </d-button>
              </div>
            </div>
          </div>
          <section>
            <div class="order__MyDatepicker_weekdays">
              <div
                class="order__MyDatepicker_weekdays_weekday"
                v-for="(weekday, index) in weekdays"
                :key="index">
                {{ weekday }}
              </div>
            </div>
            <div class="order__MyDatepicker_date">
              <div
                class="day-hidden"
                v-for="(day, index) in firstMonthDay"
                :key="'prev' + index">
                {{(prevMonth) - firstMonthDay + day }}
              </div>
              <div
                class="day"
                :class="[ day === date.date ? 'active' : '' ]"
                @click.prevent="date.date = day"
                v-for="(day, index) in currentMonth"
                :key="'day-' + index">
                {{ day }}
              </div>
              <div
                class="day-hidden"
                v-for="(day, index) in (40 - (currentMonth + firstMonthDay))"
                :key="'next' +index">
                {{ day }}
              </div>
            </div>
          </section>
        </article>
      </d-container>
    </d-modal-body>
  </d-modal>
</template>

<script>
import DatePicker from 'vue2-datepicker';

export default {
  name: 'order-form-calendar',
  components: {
    DatePicker
  },
  props: {
    weekdays: {
      type: Array,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    weekdayName: {
      type: Array,
      required: true
    },
    currentMonth: {
      type: Number,
      required: true
    },
    firstMonthDay: {
      type: Number,
      required: true
    },
    prevMonthDays: {
      type: Number,
      required: true
    },
    prevMonth: {
      type: Number,
      required: true
    },
    month: {
      type: Array,
      required: true
    },
    date: {
      type: Object,
      required: true
    },
    dateName: {
      type: Array,
      required: true
    }
  },
  methods: {
    dateUp () {
      if (this.date.date === this.currentMonth) {
        this.date.date = 1;
        this.monthUp();
      } else {
        this.date.date += 1;
      }
    },
    dateDown () {
      if (this.date.date === 1) {
        this.date.date = this.prevMonthDays;
        this.monthDown();
      } else {
        this.date.date -= 1;
      }
    },
    monthUp () {
      if (this.date.month === 12) {
        this.date.month = 1;
        this.date.year += 1;
      } else {
        this.date.month += 1;
      }
    },
    monthDown () {
      if (this.date.month === 1) {
        this.date.month = 12;
        this.date.year -= 1;
      } else {
        this.date.month -= 1;
      }
    },
    yearUp () {
      this.date.year += 1;
      this.date.yearAdd += 1;
    },
    yearDown () {
      this.date.year -= 1;
      this.date.yearAdd -= 1;
    }
  }
};
</script>

<style lang="scss">
@import '../../../assets/scss/order-list-calendar.scss';
</style>

